import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-[3px] border border-muted-foreground/50 bg-transparent transition-[background-color,border-color] duration-200 hover:border-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime/40 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-lime data-[state=checked]:bg-lime data-[state=checked]:text-ink",
      className
    )}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className="h-3 w-3" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
